import { render, staticRenderFns } from "./Magento2.vue?vue&type=template&id=a1e93c84&"
import script from "./Magento2.vue?vue&type=script&lang=js&"
export * from "./Magento2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports